export default "__VITE_ASSET__Cck89SH$__"